<shared-form-view #formView
  [formGroup]="formGroup()"
  [suggestions]="{}"
  [sections]="sections"
  [pageType]="context().pageType">
</shared-form-view>
